<div class="map-title">{{title}}</div>
<div id="map-{{id}}"></div>
<div class="stations-access-toggle">
  <label><input type="checkbox" name="stations_public" value="1" checked="checked" /> Public {{station_label}}</label>
  <label><input type="checkbox" name="stations_private" value="1" /> Private {{station_label}}</label>
</div>
